import Modal from 'components/modal';
import styled from 'styled-components';
import { useUiState } from 'state';
import Button from 'components/button';

const Content = styled.div`
  padding: 20px 15px;
  flex: 1;
  h2 {
    margin: 0px;
  }
`;

const Actions = styled.div`
  padding: 0px 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
`;

const DescriptionElement = ({ children, handleConfirm, handleCancel }) => {
  if (!children) return null;
  if (typeof children === 'function') {
    return children({ handleConfirm, handleCancel });
  }
  return <p>{children}</p>;
};

export default () => {
  const { uiState = {}, updateUiState } = useUiState();
  const { confirmationDialog } = uiState;
  if (!confirmationDialog) return null;
  const handleConfirm = () => {
    updateUiState({ confirmationDialog: undefined });
    confirmationDialog?.onConfirm && confirmationDialog?.onConfirm();
  };

  const handleCancel = () => {
    updateUiState({ confirmationDialog: undefined });
    confirmationDialog?.onCancel && confirmationDialog?.onCancel();
  };

  return (
    <Modal
      open
      height={confirmationDialog.height || 'auto'}
      maxHeight={confirmationDialog.maxHeight}
      width={confirmationDialog.width || '400px'}
      maxWidth={confirmationDialog.maxWidth}>
      <Content style={confirmationDialog.contentStyle}>
        <h2>{confirmationDialog.title}</h2>
        <DescriptionElement handleConfirm={handleConfirm} handleCancel={handleCancel}>
          {confirmationDialog.description}
        </DescriptionElement>
      </Content>
      <Actions>
        {!confirmationDialog.hideCancel && (
          <Button
            variant="secondary"
            onClick={handleCancel}
            width={confirmationDialog.cancelWidth || 80}>
            {confirmationDialog.cancelLabel || 'NO'}
          </Button>
        )}
        {!confirmationDialog.hideConfirm && (
          <Button
            variant="primary"
            onClick={handleConfirm}
            width={confirmationDialog.confirmWidth || 80}>
            {confirmationDialog.confirmLabel || 'YES'}
          </Button>
        )}
      </Actions>
    </Modal>
  );
};
